import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Jumbotron,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import axios from "axios";

export default class Login extends Component {
  state = {
    email: "",
    password: "",
    loading: false,
    error: "",
  };

  submitForm = (event) => {
    event.preventDefault();
    // console.log('in submit', { ...this.state });

    if (this.state.email && this.state.password) {
      this.setState({ loading: true });
      const load = {
        ...this.state,
      };

      axios
        .post("/api/loginUser", load)
        .then((resp) => {
          // console.log(resp.data);
          if (resp.data.isAuth) {
            localStorage.setItem("token", resp.data.token);
            this.props.history.push("/dashboard");
          }
        })
        .catch((err) => {
          console.error(err.response);
          if (!err.response.data.isAuth) {
            this.setState({ loading: false, error: err.response.data.message });
            return;
          }
          this.setState({ loading: false, error: "An error Occured" });
        });
    }
  };

  render() {
    // const jumb = {
    //   WebkitBoxShadow: '0px 0px 12px 1px rgba(0,0,0,0.4)',
    //   MozBoxShadow: '0px 0px 12px 1px rgba(0,0,0,0.4)',
    //   boxShadow: '0px 0px 12px 1px rgba(0,0,0,0.4)',
    //   backgroundColor: '#fff',
    // };
    const bg = {
      backgroundColor: "#7c7c7d",
    };
    return (
      <Container fluid style={bg}>
        <Row style={{ height: "100vh" }} className="align-items-center">
          <Col xs="12" sm="4" className="mx-auto">
            <Jumbotron
              className="ui-box-shadow-dark-light"
              style={{ backgroundColor: "#fff" }}
            >
              <Col sm="6" className="mx-auto mb-4">
                <a href="/">
                  <img
                    className="w-100"
                    src="/assets/img/checkoff-credit_logo_stripped_small.png"
                    alt=""
                  />
                </a>
              </Col>
              <Form onSubmit={this.submitForm}>
                <FormGroup>
                  <Label for="exampleEmail">Email</Label>
                  <Input
                    type="email"
                    value={this.state.email}
                    placeholder="Admin Email Address"
                    onChange={(e) => {
                      this.setState({ email: e.target.value });
                    }}
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="exampleEmail">Password</Label>
                  <Input
                    type="password"
                    value={this.state.password}
                    placeholder="Admin password"
                    onChange={(e) => {
                      this.setState({ password: e.target.value });
                    }}
                  />
                </FormGroup>
                <Button
                  type="submit"
                  block
                  className="btnprimary"
                  color="info"
                  size="md"
                  disabled={this.state.loading}
                >
                  Login
                </Button>
                <Label>{this.state.error}</Label>
              </Form>
            </Jumbotron>
          </Col>
        </Row>
      </Container>
    );
  }
}
